import type { AbilityDefinition } from '@/constants/userAbility';
import { useUserStore } from '@/stores/user';

export type AccessRule = AbilityDefinition;

export function hasAccess(ability: AccessRule | undefined, defaultWhenMissing = false): boolean {
    if (ability === undefined) {
        return defaultWhenMissing;
    }

    return useUserStore().can(ability);
}

/** Filter items with optional `access`; dedupe table headers by `key` (first match wins). */
export function filterByAccess<T extends { access?: AccessRule; key?: string }>(items: readonly T[], defaultWhenMissing = false): T[] {
    const seenKeys = new Set<string>();
    const result: T[] = [];

    for (const item of items) {
        if (!hasAccess(item.access, defaultWhenMissing)) {
            continue;
        }

        const key = item.key;
        if (key) {
            if (seenKeys.has(key)) {
                if (import.meta.env.DEV) {
                    console.warn(`[access] duplicate header key "${key}" passed access filter — skipped`);
                }
                continue;
            }
            seenKeys.add(key);
        }

        result.push(item);
    }

    return result;
}
